import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { BoardsDashboardSelector } from "common/widgets/dashboard-selector/presets";
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      icon: this.attr(`loading`) ? `spinner` : this.attr(`icon`),
      theme: this.attr(`theme`),
      pressed: this.state.isOpen,
      disabled: this.attr(`disabled`)
    },
    on: { click: this.helpers.handleSaveButtonClicked }
  }, this.attr(`label`)), this.attr(`tooltip`) && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Top, "body-level": true, text: this.attr(`tooltip`) }
  }), /* @__PURE__ */ jsx(BoardsDashboardSelector, {
    recentDashboardIds: this.state.recentDashboardIds,
    placeholder: this.attr(`search-placeholder`),
    open: this.state.isOpen,
    dashboardController: this.dashboardController,
    handleDashboardSelected: this.helpers.handleDashboardSelected,
    handleMenuChanged: this.helpers.handleMenuChanged,
    alignRight: this.attr(`align-right`)
  }));
}
